<style lang="stylus">
    .buyframe-modal
        position fixed
        overflow auto
        top 0
        right 0
        bottom 0
        left 0
        z-index 99999
        background rgba(55,55,55,.6)
        .buyframe-container
            position absolute
            width 820px
            height 566px
            top 0
            bottom 0
            left 0
            right 0
            margin auto
            background #fff
            border-radius 6px
            .buyframe-header
                width 100%
                height 24px
                position relative
                .close-icon
                    position absolute
                    width 24px
                    height 24px
                    padding 4px
                    right 2px
                    cursor pointer
        iframe
            border none
            width 100%
            height 542px
            border-radius 0 0 6px 6px
</style>

<template>
    <div class="buyframe-modal">
        <div class="buyframe-container">
            <div class="buyframe-header">
                <iconSymbol class="close-icon" name="close" @click.native="closeBuyFrame" />
            </div>
            <transition name="fade">
                <iframe ref="buyframe" id="buyframe" :src="buyUrl"></iframe>
            </transition>
        </div>
    </div>
</template>

<script>
    import { Component, Vue, Prop } from "vue-property-decorator";
    @Component({})
    export default class buyFrame extends Vue {
        @Prop({ default: "default", type: String }) type;
        @Prop({ default: () => {}, type: Function }) showCallback;
        get showCompare() {
            return this.$store.state.publicStore.showCompare;
        }
        // 获取打开内购页的埋点属性值
        get triggerName() {
            return this.$store.state.publicStore.upgradeTrigger;
        }
        get upgradeSuffix() {
            return this.$store.state.publicStore.upgradeSuffix;
        }
        get close_times() {
            return this.$store.state.publicStore.close_times;
        }
        get discount_times() {
            return this.$store.state.publicStore.discount_times;
        }
        get package_times() {
            return this.$store.state.publicStore.package_times;
        }
        get limitBuyModalTimes() {
            return this.$store.state.publicStore.limitBuyModalTimes;
        }
        get utmTerm() {
            return this.utm_term ? `&selfutm_term=${this.utm_term}` : "";
        }
        get buyUrl() {
            let baseURL = this.isTestEnv ? "https://wmp.edrawsoft.cn/cn/buyPage/buy-new.html" : "https://buy.edrawmax.cn/buy.html";
            let lang = this.lang == "zh" ? "cn" : this.lang,
                showCompare = this.showCompare ? "&action=compare" : "",
                buyTrigger = `&triggerName=${this.triggerName}`;
            let custom = "&custom=" + encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.id, token: this.userInfo.token })));
            return (
                `${baseURL}?lang=${lang}&platform=web&pid=${this.appPid}` +
                buyTrigger +
                showCompare +
                custom +
                `&${this.upgradeSuffix}` +
                this.utmTerm
            );
        }
        closeBuyFrame() {
            this.$store.commit("toPublicStatus", {
                type: "showCompare",
                data: false,
            });
            this.$store.commit("toPublicStatus", {
                type: "upgradeSuffix",
                data: "",
            });
            if (this.triggerName === "vipFuncGrid" && !this.vip) {
                let view = window["_view"];
                if (!view) return;
                view.showGridBox(true);
                this.$store.commit("setStatus", {
                    type: "removeGrid",
                    data: true,
                });
            }
            this.$emit("closeBuyFrame");
            this.sensors.track("newpay_click", {
                click_type: "close_click",
            });
            // 挽留弹窗
            if (!this.limitBuyModalTimes && !this.vip) {
                this.$store.commit("toPublicStatus", {
                    type: "close_times",
                    data: this.close_times + 1,
                });
                let bool = true;
                if (this.close_times == this.discount_times) {
                    bool = false;
                    Promise.all([
                        this.$edApi.getCouponExists({
                            user_id: this.userInfo.id,
                            token: this.userInfo.token,
                            code: "NVR7",
                        }),
                        this.$store.dispatch("setBuyModalCloseTimes"),
                    ]).then(([canBindCoupon, hasError]) => {
                        if (!canBindCoupon || hasError === 0) return;
                        if (this.type === "slider") {
                            this.showCallback(1);
                        } else {
                            this.$store.commit("toPublicStatus", {
                                type: "showBuyDiscount",
                                data: true,
                            });
                        }
                        this.sensors.track("strategicPopupOpen", {
                            popup_type: "coupon_popup",
                            popup_time: this.close_times,
                        });
                    });
                }
                if (this.close_times == this.package_times) {
                    bool = false;
                    this.$store.dispatch("setBuyModalCloseTimes").then((success) => {
                        if (!success) return;
                        if (this.type === "slider") {
                            this.showCallback(2);
                        } else {
                            this.$store.commit("toPublicStatus", {
                                type: "showBuyPackage",
                                data: true,
                            });
                        }
                        this.sensors.track("strategicPopupOpen", {
                            popup_type: "sku_popup",
                            popup_time: this.close_times,
                        });
                    });
                }
                if (bool) this.$store.dispatch("setBuyModalCloseTimes");
            }
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get vipSymbolMark() {
            return this.$store.state.vipState?.vipSymbolMark;
        }
        get vipTemplateMark() {
            return this.$store.state.vipState?.vipTemplateMark;
        }
        get vipShapeNum() {
            return this.$store.state.vipState?.vipShapeNum;
        }
        get cummunityVipTemplateMark() {
            return this.$store.state.vipState?.cummunityVipTemplateMark;
        }
        get vipPageTheme() {
            return this.$store.state.vipState?.vipPageTheme;
        }
        get vipPageColor() {
            return this.$store.state.vipState?.vipPageColor;
        }
        get vipPageConnect() {
            return this.$store.state.vipState?.vipPageConnect;
        }
        get vipPageAutoBeautify() {
            return this.$store.state.vipState?.vipPageAutoBeautify;
        }
        get vipPageBackground() {
            return this.$store.state.vipState?.vipPageBackground;
        }
        get vipDoctWatermark() {
            return this.$store.state.vipState?.vipDoctWatermark;
        }
        get vipDocPageNum() {
            return this.$store.state.vipState?.vipDocPageNum;
        }
        get vipMath() {
            return this.$store.state.vipState?.vipMath;
        }
        get vipPPTFont() {
            return this.$store.state.vipState?.vipPPTFont;
        }
        calcBenefit() {
            let str = "";
            const addStr = (key) => {
                if (str == "") {
                    str = key;
                } else {
                    str += `,${key}`;
                }
            };
            const vipTrigger = this.$store.state.publicStore.upgradeTrigger;
            if (this.vipTemplateMark || this.cummunityVipTemplateMark) {
                addStr(this.cummunityVipTemplateMark ? "cummunityVipTemplate" : "vipTemplate");
            }
            if (this.vipSymbolMark) {
                addStr("library");
            }
            if (this.vipShapeNum) {
                addStr("symbolsExceedLimit");
            }
            if (this.vipPageTheme) {
                addStr("theme");
            }
            if (this.vipPageColor) {
                addStr("themeColor");
            }
            if (this.vipPageConnect) {
                addStr("connector");
            }
            if (this.vipPageAutoBeautify) {
                addStr("oneClickBeautify");
            }
            if (this.vipPageBackground) {
                addStr("setBackgroundPop");
            }
            if (this.vipDoctWatermark) {
                addStr("customMark");
            }
            if (this.vipDocPageNum) {
                addStr("pageIcon");
            }
            if (this.vipMath || vipTrigger == "formulaEditor") {
                addStr("formulaEditor");
            }
            if (this.vipPPTFont) {
                addStr("text");
            }
            return str;
        }
        messageHandle(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params;
            let prefix = key[0] || "";
            if (prefix == "buyframe") {
                const str = key[1];
                if (str == "track") {
                    console.log("buyframe_track:", params);
                    this.sensors.track(params.eventKey, params.eventParams);
                } else if (str == "updateVipStatus") {
                    this.$store.dispatch("updateVipStatus", {
                        user_id: this.userInfo.id,
                        token: this.userInfo.token,
                    });
                } else if (str == "getTrackData") {
                    const vipTrigger = this.$store.state.publicStore.upgradeTrigger;
                    const libraryNames = this.$store.state.library?.trackedLibraryIds.map((item) => item.tableName) || [];
                    this.postMessageToFrame({
                        key: "getTrackData",
                        params: {
                            upgrade_trigger: vipTrigger,
                            library_name: libraryNames.length > 1 ? libraryNames[libraryNames.length - 1] : "",
                            trial_vip_benefit: this.calcBenefit(),
                            level2_file_type:
                                this.$store.state.user?.diagram_type == "default" ? "notFileType" : this.$store.state.user?.diagram_type,
                            level3_file_type: this.$store.state.user?.lv2_type,
                            last_click_template_name:
                                this.$store.state.last_template_name || this.$store.state.user?.last_template_name || "notUseTemplate",
                            last_click_template_type: this.$store.state.user?.lv2_type || this.$store.state.user?.diagram_type || "",
                        },
                    });
                }
            }
        }
        postMessageToFrame(msg) {
            this.$refs.buyframe.contentWindow.postMessage(msg, "*");
        }
        mounted() {
            window.addEventListener("message", this.messageHandle);
        }
        beforeDestroy() {
            window.removeEventListener("message", this.messageHandle);
        }
    }
</script>
